module.exports = __webpack_public_path__ + "0f4fa9755f480e75463e74b3dce5a3ee.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-BlackItalic.woff2
// module id = 985
// module chunks = 0